<div class="container pt-3" style="font-family: GartnerSans;">
  <button *ngFor="let bu of UniqueBUs"
        type="button"
        class="btn btn-outline-dark me-2 mb-4"
        [class.active]="buName === bu.BU"
        (click)="onAccountChange(bu.BU)">
  {{ bu.BU }}
  <span class="badge bg-success ms-2" style="font-family: GartnerSans;">{{ bu.count }}</span>
</button>
<button *ngIf="buName"
        type="button"
        class="btn btn-outline-secondary ms-2 mb-2"
        style="font-family: GartnerSans;"
        (click)="onAccountChange(null)">
  Clear Account Filter
</button>
  <div class="card shadow-lg p-4">
    <h4 class="small fw-semibold mb-4" style="font-family: GartnerSans;">INVENTORY REPORT</h4>
    

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <div class="form-floating-sm">
  <input 
    type="text" 
    class="form-control" 
    id="filterInput" 
    placeholder="Filter..." 
    (input)="applyFilter($event)"
  >
</div>

<!-- Loading Bar -->
<div *ngIf="showProgress" class="text-center">
  <img src="assets/loader.gif" class="loading-gif">
</div>

  <div class="table-responsive">
    <table class="table table-striped table-hover align-middle" mat-table [dataSource]="dataSource" matSort>
    
    <!-- Dynamic column definitions -->
    <ng-container matColumnDef="columnName" *ngFor="let column of displayedColumns" [matColumnDef]="column">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header class="text-uppercase medium fw-semibold px-3 py-2" style="font-family: GartnerSans;"> {{ column }} </th>
      <td mat-cell *matCellDef="let element" class="small px-3 py-2" style="font-family: GartnerSans;"> {{ element[column] }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>





  

    <!-- <br> -->
    <hr>
    <mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 20, 25]" showFirstLastButtons></mat-paginator>
  </div>
</div>
